import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { PackageResponse } from "src/domain/client";
import { TranslateModule } from "@ngx-translate/core";
import { TotalPriceComponent } from "../total-price/total-price.component";

@Component({
  selector: "app-package-container-v2",
  imports: [TranslateModule, TotalPriceComponent],
  templateUrl: "./package-container-v2.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageContainerV2Component {
  package = input<PackageResponse>();
  parentForm = input<FormGroup<any>>();
  isParentPackage = input<boolean>(false);
  displaySubPackages = input<boolean>(false);
  subPackagesTitle = input<string>();

  extraServicesParentForm(id: string): FormGroup<any> {
    return this.parentForm().get(id) as FormGroup<any>;
  }
}
